// user action constants
import { UI_SET_ALERT } from '../types'

export const setAlert = (type, message) => ({
  type: UI_SET_ALERT,
  payload: { type, message }
})
